import { useMemo } from 'react';

import { useLocation } from 'react-router';

import { parseUrlToState } from '#src/app/pages/search/shared/api';
import type { SearchState } from '#src/app/pages/search/shared/api';

/**
 * Filter/search state derived from the URL (the single source of truth). Re-parses only when the
 * query string changes, so consumers of this hook re-render on URL changes and nothing else.
 */
export function useSearchState(): SearchState {
	const location = useLocation();
	return useMemo(() => parseUrlToState(location.search), [location.search]);
}
